import { initSwiper } from '@resources/js/components/initSwiper.js'
import inViewport from '@resources/js/helpers/inViewport'
import { isMobile } from '@resources/js/helpers/media'
import Toggle from '@resources/js/ui/Toggle'
import addSlidesToSlider from '@resources/js/helpers/addSlidesToSlider'

const topHotelCardElements = document.querySelectorAll('.js-top-hotel-card')

if (topHotelCardElements.length) {
	topHotelCardElements.forEach(hotelElement => {
		inViewport(hotelElement, () => {
			// додаємо клас, щоб дочірні елементи стискались
			// по дефолту мають бути розгорнуті для ботів
			hotelElement.classList.add('collapsed')

			initHotelCardSlider(hotelElement)

			isMobile()
				? initHotelCardDescriptionToggleMob(hotelElement)
				: initHotelCardDescriptionToggle(hotelElement)
		})
	})
}

const initHotelCardSlider = hotelCardElement => {
	const sliderContainerElement = hotelCardElement.querySelector(
		'.js-slider-container'
	)
	if (!sliderContainerElement) return

	const swiperElement = sliderContainerElement.querySelector('.js-slider')

	const swiperConfig = {
		loop: false,
		spaceBetween: 0,
		navigation: {
			prevEl: sliderContainerElement.querySelector('.js-slider-prev-btn'),
			nextEl: sliderContainerElement.querySelector('.js-slider-next-btn'),
		},
		pagination: {
			el: sliderContainerElement.querySelector('.swiper-pagination'),
			type: 'bullets',
			dynamicBullets: true,
			dynamicMainBullets: 3,
		},
	}

	initSwiper(swiperElement, swiperConfig)

	swiperElement.swiper.once('slideChange', () =>
		addSlidesToSlider(swiperElement, { width: 490, height: 340 })
	)
}


const initHotelCardDescriptionToggle = hotelCardElement => {
	const hotelInfoElement = hotelCardElement.querySelector('.js-hotel-info-block')
	const toggleTextBtnElement =
		hotelCardElement.querySelector('.js-toggle-text-btn')

	if (!toggleTextBtnElement) return

	const descriptionToggle = new Toggle(toggleTextBtnElement, {
		target: hotelInfoElement,
		toggleClass: 'expand',
	})

	const hotelInfoElementHeight = getComputedStyle(hotelInfoElement).height

	descriptionToggle.on('show', () => {
		hotelInfoElement.style.height = hotelInfoElementHeight
	})

	descriptionToggle.on('hide', () => {
		hotelInfoElement.style.height = '100%'
	})
}

const initHotelCardDescriptionToggleMob = hotelCardElement => {
	const descriptionElement = hotelCardElement.querySelector('.js-mob-description')
	const toggleIconElement = hotelCardElement.querySelector('.js-toggle-descr-icon')

	if (!descriptionElement || !toggleIconElement) return

	new Toggle(toggleIconElement, { target: descriptionElement })
}
